(function () {
    'use strict';

    angular
        .module('core.services')
        .service('StateService', StateService)

    /** @ngInject */
    function StateService(HttpService) {
        const StateService = {
            getAll: getAll
        }

        return StateService;

        function getAll() {
            return HttpService.get('/states');
        }
    }
}());